import type { Type } from '@angular/core';
import metadata from './feature-views.json';
export const FEATURE_VIEW_DEFINITIONS = metadata as Record<string, { views: string[] }>;
export const FEATURE_LOADERS: Record<string, () => Promise<Type<unknown>>> = {
  'catalog': () => import('../../shared/features/catalog/catalog.controller').then(m => m.CatalogController),
  'access': () => import('../../shared/features/access/access.controller').then(m => m.AccessController),
  'entities': () => import('../../shared/features/entities/entities.controller').then(m => m.EntityController),
  'pipeline': () => import('../../shared/features/pipeline/pipeline.controller').then(m => m.PipelineController),
  'pipelines': () => import('../../shared/features/pipelines/pipelines.controller').then(m => m.PipelineListController),
  'audit': () => import('../../shared/features/audit/audit.controller').then(m => m.AuditController),
  'pricing': () => import('../../shared/features/pricing/pricing.controller').then(m => m.PricingController),
};
